import Axios from 'axios'
import { useAuthentication } from 'providers/Authentication'

export interface IFileUploadResult {
  id: string
  mimeType: string
  apiUrl: string
  publicUrl: string
}

const FILE_SERVER_URL = 'https://the-file-server.nightzookeeper.com'

export const FileServer = {
  upload: async (file: File, token: string, transforms?: string): Promise<IFileUploadResult> => {
    const formData = new FormData()
    formData.append('file', file)
    const { data } = await Axios.post(`${FILE_SERVER_URL}/images${transforms ? `/${transforms}` : ''}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })
    return data
  },
  uploadV2: async (file: File, token: string, path?: string, transforms?: string): Promise<IFileUploadResult> => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', path || '/')
    const { data } = await Axios.post(`${FILE_SERVER_URL}/v2/images${transforms ? `/${transforms}` : ''}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })
    return data
  }
}

export const useFileServer = () => {
  const { token } = useAuthentication()

  const upload = async (file: File, transforms?: string): Promise<IFileUploadResult | null> => {
    if (!token) return null
    return FileServer.upload(file, token.accessToken?.value, transforms)
  }

  return { upload }
}
